/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolRavenIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-raven"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M5.7 4.75Q5.7 4.75 5.49 4.75Q5.28 4.75 4.99 5.04Q4.7 5.33 4.7 5.75Q4.7 6.17 4.99 6.46Q5.28 6.75 5.7 6.75Q6.13 6.75 6.41 6.46Q6.7 6.17 6.7 5.75Q6.7 5.33 6.41 5.04Q6.13 4.75 5.7 4.75ZM10.1 18.52L8.8 21.6Q8.6 22.1 8.1 22.3Q7.6 22.5 7.1 22.3Q6.6 22.1 6.39 21.59Q6.17 21.07 6.38 20.57L7.4 18.18Q4.7 17.43 2.95 15.3Q1.2 13.18 1.2 10.4L1.2 5.65Q1.2 3.8 2.5 2.5Q3.8 1.2 5.67 1.2Q6.15 1.2 6.6 1.29Q7.05 1.38 7.47 1.57L13.3 4.03Q13.72 4.2 13.71 4.65Q13.7 5.1 13.28 5.25L10.18 6.42L10.18 7.65L17.68 12.28L9.9 12.28Q9.1 12.28 8.43 11.94Q7.75 11.6 7.55 10.95Q7.42 10.5 7.09 10.2Q6.75 9.9 6.25 9.9Q5.7 9.9 5.33 10.28Q4.95 10.65 4.95 11.2Q4.95 12.22 5.69 12.97Q6.42 13.72 7.08 14.13Q7.7 14.5 8.41 14.7Q9.13 14.9 9.9 14.9L21.93 14.9L21.93 14.9L22.68 20.82Q22.73 21.23 22.48 21.51Q22.23 21.8 21.82 21.8L21.13 21.8Q20.93 21.8 20.74 21.7Q20.55 21.6 20.43 21.43L18.38 18.52L14.4 18.52L14.4 21.5Q14.4 22.05 14.03 22.43Q13.65 22.8 13.1 22.8Q12.55 22.8 12.16 22.41Q11.78 22.02 11.78 21.48L11.78 18.52Z" fill={color} />
    </svg>
  );
}
